import { getClient } from '@lib/sanity';

// Note: Not used
export async function fetchSingleLocationProducts(locale, preview = false, slug) {
  return await getClient(preview).fetch(`
    *[_type == 'page' && slug.current =='${ slug }'][0]{
      sectionBox[@._type == 'multiContactSection'] {
        products[] {
          productName
        }
      }
    }.sectionBox[0].products
  `);
}

export async function fetchKinderopvangLocationsNames(locale, preview = false) {

  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && level == 3 && domain == "kinderopvang"] {
      pageTitle,
      locationCode,
      'products': tabs[label != "Onze locatie"][] {
        'productName': label,
        'city': sectionBox[@._type == 'contactSection'][0].city
      }
    }
  `);
}

// Note: Not used
export async function fetchKinderopvangLocations(locale, preview = false) {

  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && __i18n_lang == "${ locale }" && level == 3 && domain == "kinderopvang"] {
      _id,
      pageTitle,
      slug,
      geoLocation {
        lat,
        lng
      },
      locationCode,
      cardImage,
      __i18n_lang,
      sectionBox[@._type == 'multiContactSection'] {
        ...
      }
    }
  `);
}

export async function fetchLocations(locale, preview = false) {
  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && __i18n_lang == "${ locale }" && level == 3 && domain == "kinderopvang"] {
      _id,
      pageTitle,
      slug,
      geoLocation {
        lat,
        lng
      },
      locationCode,
      cardImage,
      __i18n_lang,
      "sectionBox": [{
        "_type": "multiContactSection",
        "products": tabs[label != "Onze locatie"][] {
          "productName": select(
            label == "Buitenschoolse opvang" => "BSO",
            label == "Kinderdagverblijf" => "KDV",
            label == "Peuteropvang" => "POV"
          ),
          "contactDetails": sectionBox[_type == 'contactSection'][0] {
            "zipCode": zipCode,
            "city": city,
            "address": address,
            "email": email,
            "phoneNumber": phoneNumber
          }
        }
      }],
      parentSlug,
    } | order(lower(pageTitle) asc)
  `);
}

export async function fetchLocationsByCity(locale, city, preview = false) {
  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && __i18n_lang == "${ locale }" && level == 3 && domain == "kinderopvang" && parentSlug == "${ city }"] {
      _id,
      pageTitle,
      slug,
      geoLocation {
        lat,
        lng
      },
      locationCode,
      cardImage,
      __i18n_lang,
      "sectionBox": [{
        "_type": "multiContactSection",
        "products": tabs[label != "Onze locatie"][] {
          "productName": select(
            label == "Buitenschoolse opvang" => "BSO",
            label == "Kinderdagverblijf" => "KDV",
            label == "Peuteropvang" => "POV"
          ),
          "contactDetails": sectionBox[_type == 'contactSection'][0] {
            "zipCode": zipCode,
            "city": city,
            "address": address,
            "email": email,
            "phoneNumber": phoneNumber
          }
        }
      }],
      parentSlug,
    } | order(lower(pageTitle) asc)
  `);
}
